import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Divider, Section } from 'components'

import * as Styles from './Clients.module.css'

const Clients = ({ divider }) => {
  const {
    allWpClient: { nodes: clientData },
  } = useStaticQuery(query)

  return (
    <Section>
      <div className={Styles.wrapper}>
        <Divider data={divider} />

        <div className="flex justify-center items-center flex-wrap gap-8">
          {clientData.map(({ title, clientInfo }) => {
            return !clientInfo.feature ? (
              false
            ) : (
              <GatsbyImage
                className="w-40"
                title={title}
                key={title}
                alt={clientInfo.logo.altText ? clientInfo.logo.altText : title}
                image={getImage(clientInfo.logo.localFile)}
              />
            )
          })}
        </div>
      </div>
    </Section>
  )
}

export const query = graphql`
  {
    allWpClient {
      nodes {
        title
        clientInfo {
          logo {
            altText
            description
            title
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  width: 600
                  placeholder: DOMINANT_COLOR
                  layout: FULL_WIDTH
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
          }
          caseStudy
          feature
          fieldGroupName
          order
          website
        }
      }
    }
  }
`

export default Clients
